/**
 * API: Reporte de Estimación de Alumnado (Control Escolar).
 *
 * Endpoint: GET /api/escolar/reportes/estimacion-alumnado/
 *
 * Filtros soportados:
 *  - id_ciclo_escolar (req)
 *  - id_campus        (opc)
 *  - id_seccion       (opc)
 *  - id_programa      (opc — si vacío devuelve todos los programas de la sección)
 *  - id_institucion   (opc)
 *  - all              (opc, '1' devuelve todo sin paginar; para export XLS)
 */

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

function getAuthToken() {
  return localStorage.getItem('authToken');
}

function getHeaders() {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

/**
 * @param {Object} params
 * @param {number|string} params.id_ciclo_escolar
 * @param {number|string} [params.id_campus]
 * @param {number|string} [params.id_seccion]
 * @param {number|string} [params.id_programa]
 * @param {number|string} [params.id_institucion]
 * @returns {Promise<{filtros:object, programas:Array}>}
 */
export async function getReporteEstimacionAlumnado({
  id_ciclo_escolar,
  id_campus,
  id_seccion,
  id_programa,
  id_institucion,
} = {}) {
  if (!id_ciclo_escolar) {
    throw new Error("El parámetro 'id_ciclo_escolar' es requerido.");
  }

  const qs = new URLSearchParams();
  qs.set('id_ciclo_escolar', String(id_ciclo_escolar));
  if (id_campus) qs.set('id_campus', String(id_campus));
  if (id_seccion) qs.set('id_seccion', String(id_seccion));
  if (id_programa) qs.set('id_programa', String(id_programa));
  if (id_institucion) qs.set('id_institucion', String(id_institucion));

  const url = `${API_BASE}/escolar/reportes/estimacion-alumnado/?${qs.toString()}`;

  const res = await fetch(url, { headers: getHeaders() });

  if (!res.ok) {
    let detail = `Error ${res.status}`;
    try {
      const body = await res.json();
      detail = body.error || body.detail || detail;
    } catch (_) { /* ignore */ }
    throw new Error(detail);
  }

  return res.json();
}
